import { createContext } from 'react'

import { ResourcesContextValue } from './ResourcesContext.types'

export const ResourcesContext = createContext<ResourcesContextValue | undefined>(undefined)
